export const styles = {
  dataTableStyle: {
    borderRadius: 24,
    overflow: 'hidden',
  },
};
